function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2533.11,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M26917 26916l9672 9673m-7012 -23366c-2693,-6339 -10016,-9293 -16354,-6599 -6339,2693 -9293,10016 -6599,16354 2693,6339 10016,9293 16354,6599 6339,-2693 9293,-10016 6599,-16354z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 42216 42216",
    className: "icon",
    style: {
      "height": "1em",
      "width": "1em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/search.84216329.svg";
export { SvgComponent as ReactComponent };